import {FortunePrizeGenqlSelection} from "@/gql/gen";

export const FortunePrizeFields: FortunePrizeGenqlSelection = {
    ID: true,
    NAME: true,
    CODE: true,
    ACTIVE: true,
    SORT: true,
    DETAIL_TEXT: true,
    PREVIEW_PICTURE: {
        __fragment: 'Image'
    },
    DETAIL_PICTURE: {
        __fragment: 'Image'
    },

    PRIZE_TYPE: true,
    PROBABILITY: true,
    GIFT_ELEMENT: true,
    DISCOUNT_ELEMENT: true,
    BACKGROUND_COLOR: true,
    TEXT_COLOR: true,
    TEXT_ORIENTATION: true,

    PROPERTIES: {
        PRIZE_TYPE: true,
        GIFT_ELEMENT: true,
        DISCOUNT_ELEMENT: true,
        BACKGROUND_COLOR: true,
        TEXT_COLOR: true,
        TEXT_ORIENTATION: {
            __fragment: 'ListValue'
        },
        PROBABILITY: true,
    }
}




